/*
 * @Author: cmchiu
 * @Date: 2022-09-06 09:48:38
 * @LastEditTime: 2022-09-30 18:03:41
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \LearningMarket\LearningMarket-ClientApp\src\api\course.js
 *
 */
import request from '@/utils/request'

export const getCourseClass = params => {
    return request({
        url: '/Course/GetCourseClass',
        method: 'get',
        params,
    })
}

export const getCourseList = params => {
    return request({
        url: '/Course/GetCourseList',
        method: 'get',
        params,
    })
}

export const getCourseInfo = params => {
    return request({
        url: '/Course/GetCourseInfo',
        method: 'get',
        params,
    })
}

export const getMyCourse = data => {
    return request({
        url: '/Course/GetMyCourse',
        method: 'post',
        data,
    })
}

export const getMyCoursePast = data => {
    return request({
        url: '/Course/GetMyCoursePast',
        method: 'post',
        data,
    })
}

export const getMyCourseOther = data => {
    return request({
        url: '/Course/GetMyCourseOther',
        method: 'post',
        data,
    })
}

export const cancelBook = data => {
    return request({
        url: '/Course/CancelBook',
        method: 'post',
        data,
        timeout: 300000,
    })
}

export const getFeedbackList = data => {
    return request({
        url: '/Course/GetFeedbackList',
        method: 'post',
        data,
    })
}

export const updateBookingFeedback = data => {
    return request({
        url: '/Course/UpdateBookingFeedback',
        method: 'post',
        data,
    })
}

export const checkBookingRole = data => {
    return request({
        url: '/Course/CheckBookingRole',
        method: 'post',
        data,
    })
}

export const checkBookingStatus = data => {
    return request({
        url: '/Course/CheckBookingStatus',
        method: 'post',
        data,
    })
}

export const checkBooking = data => {
    return request({
        url: '/Course/CheckBooking',
        method: 'post',
        data,
    })
}

export const bookCourse = data => {
    return request({
        url: '/Course/BookCourse',
        method: 'post',
        data,
        timeout: 300000,
    })
}

export const getCourseType4Demand = () => {
    return request({
        url: '/Course/GetCourseType4Demand',
        method: 'get',
    })
}

export const submitCourseDemand = data => {
    return request({
        url: '/Course/SubmitCourseDemand',
        method: 'post',
        data,
        timeout: 300000,
    })
}

const course = {
    getCourseClass,
    getCourseList,
    getCourseInfo,
    getMyCourse,
    getMyCoursePast,
    getMyCourseOther,
    cancelBook,
    getFeedbackList,
    updateBookingFeedback,
    checkBookingRole,
    checkBookingStatus,
    checkBooking,
    bookCourse,
    getCourseType4Demand,
    submitCourseDemand,
}
export default course
